import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import { useLocation } from "react-router-dom";
import axios from "axios";
import SpeechRecognition, {
    useSpeechRecognition,
} from "react-speech-recognition";
import LanguagesDropdown from "../components/LanguagesDropdown";
import AceEditor from "react-ace";
import { languageOptions } from "../constants/languageOptions";
import Spinner from "../components/Spinner";

const javascriptDefault = ``;
function InterviewSession() {
    const location = useLocation();
    const { groupId, problemId } = location.state || {};

    const [user_message, setuser_message] = useState("Hello, Please take my interview");
    const [allMessages, setallMessages] = useState([]);
    const [start_interview, setstart_interview] = useState(false);
    const [interview_questions, setinterview_questions] = useState([]);
    const [seconds, setSeconds] = useState(60);
    const [time_up, settime_up] = useState(false);
    const [editor_mode, seteditor_mode] = useState("c_cpp");
    const [code, setCode] = useState(javascriptDefault);
    const [language, setLanguage] = useState(languageOptions[0]);
    const [aiThinking, setaiThinking] = useState(false)
    const assistantRef = useRef(null);
    const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    // Debug: show transcript in console
    useEffect(() => {
        const container = assistantRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
        fetchMessages()
    }, []);

    const handleChange = (event) => {
        setuser_message(event.target.value);
    };

    const StartInterview = () => {
        setstart_interview(true);
        setSeconds(60);
        settime_up(false);
    };

    const onChange = (data) => {
        setCode(data);
    };

    const onSelectChange = (sl) => {
        setLanguage(sl);
        if (sl.id === 54) {
            seteditor_mode("c_cpp");
        } else if (sl.id === 62) {
            seteditor_mode("java");
        } else {
            seteditor_mode("python");
        }
    };

    const fetchMessages = async () => {
        const data = {
            groupId: groupId,
            problemId: problemId
        };
        axios.get('https://ed-tech-backend-eight.vercel.app/getMessages/', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: data
        })
            .then((res) => {
                console.log(res);
                const msgs = res.data.response.map((msg) => ({
                    role: msg.role,
                    content: msg.content,
                }));

                setallMessages(msgs);

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }

    const talkToAI = async () => {
        setaiThinking(true)
        const data = {
            user_message: transcript,
            groupId: groupId,
            problemId: problemId,
            code: code
        };

        try {
            const res = await axios.post('https://ed-tech-backend-eight.vercel.app/chat/', data, {
                headers: { 'Content-Type': 'application/json' },
            });

            const msgs = res.data.response.map((msg) => ({
                role: msg.role,
                content: msg.content,
            }));

            setallMessages(msgs);
            resetTranscript()
            setaiThinking(false)
        } catch (err) {
            console.error("Error talking to AI:", err);
        }
    };

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser does not support speech recognition.</span>;
    }

    return (
        <div className="h-screen flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x p-4">
            {/* Assistant Section */}
            <div className="flex-1 p-4">
                <div ref={assistantRef} className="h-full rounded-xl p-4 overflow-y-auto overflow-x-hidden">
                    <h2 className="text-xl font-semibold">Assistant</h2>
                    {allMessages.map((msg, i) => (
                        <>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            {msg.role === 'assistant' ?
                                <div className="chat chat-start">
                                    <div className="chat-image avatar">
                                        <div className="w-10 rounded-full">
                                            <img
                                                alt="Tailwind CSS chat bubble component"
                                                src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp" />
                                        </div>
                                    </div>
                                    <div className="chat-bubble chat-bubble-primary">{msg.role}: {msg.content}</div>
                                </div>
                                :
                                <div className="chat chat-end">
                                    <div className="chat-bubble chat-bubble-success">{msg.role}: {msg.content}</div>
                                </div>
                            }
                            <br></br>
                            <br></br>
                        </>
                    ))}
                    {aiThinking && <Spinner />}
                </div>
            </div>

            {/* User Section */}
            <div className="flex-1 p-4">
                <div className="h-full rounded-xl shadow-md p-4 overflow-y-auto overflow-x-hidden">
                    <h2 className="text-xl font-semibold mb-2">You</h2>
                    <p>Do not add code untill asked</p>
                    <LanguagesDropdown
                        onSelectChange={onSelectChange}
                    />
                    <br></br>
                    <AceEditor
                        mode={editor_mode}
                        theme="terminal"
                        onChange={onChange}
                        name="UNIQUE_ID_OF_DIV"
                        value={code}
                        width="100%"
                        height="80%"
                        fontSize={16}
                        placeholder=""
                        editorProps={{
                            $blockScrolling: true,
                        }}
                        setOptions={{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            enableSnippets: true,
                        }}
                    />
                </div>
            </div>

            {/* Actions Section */}
            <div className="flex-1 p-4">
                <div className="h-full rounded-xl shadow-md p-4 overflow-y-auto overflow-x-hidden flex flex-col items-center justify-start">
                    <h2 className="text-xl font-semibold mb-4">Actions</h2>
                    <p className="mb-4">Microphone status: <strong>{listening ? "on" : "off"}</strong></p>

                    <div className="flex flex-col gap-4 w-full max-w-xs">
                        <button
                            className="bg-primary text-white px-4 py-2 rounded hover:bg-blue-600 transition w-full"
                            onClick={() =>
                                SpeechRecognition.startListening({ continuous: true, language: "en-IN" })
                            }
                        >
                            Start Recording
                        </button>

                        <button
                            className="bg-primary text-white px-4 py-2 rounded hover:bg-yellow-600 transition w-full"
                            onClick={() => SpeechRecognition.stopListening()}
                        >
                            Stop Recording
                        </button>

                        <button
                            className="bg-primary text-white px-4 py-2 rounded hover:bg-green-600 transition w-full"
                            onClick={talkToAI}
                        >
                            Submit Answer
                        </button>

                        <button
                            className="bg-primary text-white px-4 py-2 rounded hover:bg-green-600 transition w-full"
                            onClick={resetTranscript}
                        >
                            Clear Answer
                        </button>
                        {transcript}

                    </div>
                </div>
            </div>

        </div>
    );
}

export default InterviewSession;
